module.exports = "/images/content-img-1.jpg?228da091c6132e699b69c9bf073e2fa9";